module.exports = __webpack_public_path__ + "img/deal.8565d788.jpg";